var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twiter",
    transform: "translate(-1522 -12220)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6844",
    "data-name": "Rectangle 6844",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(1522 12220)",
    fill: "#02a2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M16.15,7.024c.011.16.011.32.011.48A10.424,10.424,0,0,1,5.665,18,10.425,10.425,0,0,1,0,16.344a7.632,7.632,0,0,0,.891.046,7.388,7.388,0,0,0,4.58-1.576,3.7,3.7,0,0,1-3.449-2.558,4.652,4.652,0,0,0,.7.057,3.9,3.9,0,0,0,.971-.126A3.69,3.69,0,0,1,.731,8.566V8.52A3.715,3.715,0,0,0,2.4,8.989,3.695,3.695,0,0,1,1.256,4.055a10.486,10.486,0,0,0,7.607,3.86,4.165,4.165,0,0,1-.091-.845,3.693,3.693,0,0,1,6.385-2.524A7.263,7.263,0,0,0,17.5,3.655a3.679,3.679,0,0,1-1.622,2.033A7.4,7.4,0,0,0,18,5.117a7.93,7.93,0,0,1-1.85,1.907Z",
    transform: "translate(1529 12225.619)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.c0f8cd6f67df9734da22d132fb88d3a9.svg";
export { ForwardRef as ReactComponent };